var React = require('react');

function Armor (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cls-1{fill:none;stroke:#000;stroke-linecap:square;stroke-linejoin:bevel;stroke-width:2px;}")),React.createElement("title",{"key":1},"Armor Logistics"),React.createElement("polygon",{"className":"cls-1","points":"46.46 116.62 81.54 116.62 81.54 81.54 116.62 81.54 116.62 46.46 81.54 46.46 81.54 11.38 46.46 11.38 46.46 46.46 11.38 46.46 11.38 81.54 46.46 81.54 46.46 116.62","key":2})]);
}

Armor.defaultProps = {"id":"svg8","viewBox":"0 0 128 128"};

module.exports = Armor;

Armor.default = Armor;
